/* global module, require */
const keys = require('./objectKeys');

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries
function objectEntries(obj) {
	var props = keys(obj),
		i = props.length,
		results = new Array(i); // preallocate the Array
	while (i--) results[i] = [props[i], obj[props[i]]];

	return results;
}

module.exports = Object.entries ? Object.entries : objectEntries;
